import Vue from 'vue';
import RenderedSpan from '@/components/rendered-span.vue';

Vue.component('RenderedSpan', RenderedSpan);
